import { CssBaseline, ThemeProvider } from "@mui/material";
import { Outlet } from "react-router";
import { useThemeContext } from "../contexts/theme/useThemeContext";

export const RootLayout = () => {
  const { muiTheme } = useThemeContext();

  return (
    <>
      <ThemeProvider theme={muiTheme}>
        <CssBaseline />
        <Outlet />
      </ThemeProvider>
    </>
  );
};
